import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface TimeSheetHasChangesState {
    hasChangesFromReviewer: boolean
  }

const initialState: TimeSheetHasChangesState = {
    hasChangesFromReviewer: false
}
export const timesheetApprovalHasChangesSlice = createSlice({
    name: 'timesheetApprovalHasChanges',
    initialState,
    reducers: {
      hasChanges: (state, action: PayloadAction<TimeSheetHasChangesState>) => {
        state.hasChangesFromReviewer = action.payload.hasChangesFromReviewer
      }
    }
});

export const { hasChanges } = timesheetApprovalHasChangesSlice.actions